// extracted by mini-css-extract-plugin
export default {"mobileContainer":"lgW0si","overlay":"PnUuFo","svgContainer":"X8YxNy"};